/* ArtemiStreet - Showcase v3 : carrousel natif, galerie, fiche, panier */
(function () {
  'use strict';
  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }

  function initShowcase(root) {
    var hero = root.querySelector('.art-sc__hero');
    var heroInner = root.querySelector('[data-hero-inner]');
    var htrack = root.querySelector('[data-htrack]');
    var hslides = [].slice.call(root.querySelectorAll('.art-sc__hslide'));
    var ambs = [].slice.call(root.querySelectorAll('.art-sc__amb'));
    var dots = [].slice.call(root.querySelectorAll('.art-sc__dot'));
    var cta = root.querySelector('[data-cta]');
    var prods = [].slice.call(root.querySelectorAll('.art-sc__prod'));
    var detail = root.querySelector('[data-detail]');
    var sticky = root.querySelector('[data-sticky]');
    var n = prods.length, idx = 0;
    if (!n) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var rootEl = document.documentElement;
    var lb = null, lbUrls = [], lbIdx = 0;
    var vis = { detail: false, actions: false, scrolled: false };

    root.classList.add('is-ready');

    function measureHdr() {
      var h = document.querySelector('.section-header');
      var v = h ? Math.max(0, Math.round(h.getBoundingClientRect().bottom + window.scrollY)) : 0;
      root.style.setProperty('--art-hdr', v + 'px');
    }
    function activeCard() { return prods[idx]; }

    /* barre d'ajout collante */
    function syncSticky() {
      if (!sticky) return;
      var card = activeCard(); if (!card) return;
      var t = sticky.querySelector('[data-sticky-title]');
      var p = sticky.querySelector('[data-sticky-price]');
      var l = sticky.querySelector('[data-sticky-label]');
      var b = sticky.querySelector('[data-sticky-add]');
      var pr = card.querySelector('[data-price]');
      var al = card.querySelector('[data-add-label]');
      var add = card.querySelector('[data-add]');
      if (t) t.textContent = card.getAttribute('data-title') || '';
      if (p && pr) p.textContent = pr.textContent;
      if (l && al) l.textContent = al.textContent;
      if (b) b.disabled = !!(add && add.disabled);
    }
    function updSticky() {
      if (!sticky) return;
      var show = vis.detail && vis.scrolled && !vis.actions && !rootEl.classList.contains('art-more-open');
      sticky.classList.toggle('is-show', show);
    }
    var ioAct = null;
    function observeActions() {
      if (!('IntersectionObserver' in window) || !sticky) return;
      if (ioAct) ioAct.disconnect();
      var a = activeCard().querySelector('[data-actions]');
      if (!a) return;
      vis.actions = false;
      ioAct = new IntersectionObserver(function (es) {
        es.forEach(function (e) { vis.actions = e.isIntersecting; });
        updSticky();
      }, { threshold: 0.1 });
      ioAct.observe(a);
    }

    function setActive(i) {
      idx = clamp(i, 0, n - 1);
      ambs.forEach(function (a, k) { a.classList.toggle('is-active', k === idx); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === idx); });
      if (cta && hslides[idx]) cta.setAttribute('href', hslides[idx].getAttribute('data-url'));
      prods.forEach(function (p, k) { p.hidden = k !== idx; });
      [idx - 1, idx + 1].forEach(function (j) {
        var s = hslides[(j + n) % n];
        var im = s && s.querySelector('img');
        if (im) im.loading = 'eager';
      });
      syncSticky();
      observeActions();
    }

    /* carrousel d'accueil : défilement natif */
    if (htrack) {
      var tickH = false;
      htrack.addEventListener('scroll', function () {
        if (tickH) return;
        tickH = true;
        requestAnimationFrame(function () {
          tickH = false;
          var i = clamp(Math.round(htrack.scrollLeft / (htrack.clientWidth || 1)), 0, n - 1);
          if (i !== idx) setActive(i);
        });
      }, { passive: true });
    }
    function go(i) {
      if (!htrack || n < 2) return;
      htrack.scrollTo({ left: ((i + n) % n) * htrack.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
    }
    var prevBtn = root.querySelector('[data-prev]');
    var nextBtn = root.querySelector('[data-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { go(idx - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(idx + 1); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });

    var cue = root.querySelector('[data-cue]');
    if (cue && detail) cue.addEventListener('click', function (e) {
      e.preventDefault();
      var top = detail.getBoundingClientRect().top + window.scrollY - 64;
      window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
    });

    /* scroll : légère profondeur sur l'accueil + barre collante */
    var sraf = 0, heroH = 0, lastP = -1;
    function onScroll() {
      if (sraf) return;
      sraf = requestAnimationFrame(function () {
        sraf = 0;
        var y = window.scrollY;
        if (heroInner && heroH && !reduce) {
          var p = clamp(y / (heroH * 0.9), 0, 1);
          if (p !== lastP) {
            lastP = p;
            heroInner.style.transform = 'translate3d(0,' + (p * heroH * 0.12).toFixed(1) + 'px,0)';
            heroInner.style.opacity = (1 - p * 0.85).toFixed(3);
          }
        }
        var sc = y > 200;
        if (sc !== vis.scrolled) { vis.scrolled = sc; updSticky(); }
      });
    }
    function measure() {
      measureHdr();
      heroH = hero ? hero.offsetHeight : 0;
      onScroll();
    }

    /* apparition douce */
    if ('IntersectionObserver' in window) {
      var ioRv = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); ioRv.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
      [].forEach.call(root.querySelectorAll('.art-rv'), function (el) { ioRv.observe(el); });
      if (detail && sticky) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) { vis.detail = e.isIntersecting; });
          updSticky();
        }, { threshold: 0 }).observe(detail);
      }
    } else {
      [].forEach.call(root.querySelectorAll('.art-rv'), function (el) { el.classList.add('is-in'); });
    }

    /* galerie : miniatures synchronisées avec le swipe */
    prods.forEach(function (card) {
      var gal = card.querySelector('[data-gal]');
      if (!gal) return;
      var thumbs = [].slice.call(card.querySelectorAll('[data-thumb]'));
      var tk = false;
      gal.addEventListener('scroll', function () {
        if (tk) return;
        tk = true;
        requestAnimationFrame(function () {
          tk = false;
          var i = Math.round(gal.scrollLeft / (gal.clientWidth || 1));
          thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
        });
      }, { passive: true });
    });

    /* zoom photo plein écran */
    function lbShow() { if (lb) lb.querySelector('img').src = lbUrls[lbIdx]; }
    function closeLb() {
      if (!lb) return;
      lb.parentNode.removeChild(lb); lb = null;
      rootEl.classList.remove('art-more-open');
      updSticky();
    }
    function lbNav(d) { lbIdx = (lbIdx + d + lbUrls.length) % lbUrls.length; lbShow(); }
    function openLb(urls, start) {
      lbUrls = urls; lbIdx = start;
      lb = document.createElement('div');
      lb.className = 'art-lb';
      lb.innerHTML = '<img alt="">' +
        '<button type="button" class="art-lb__close" aria-label="Fermer">&times;</button>' +
        (urls.length > 1 ? '<button type="button" class="art-lb__prev" aria-label="Photo précédente">&lsaquo;</button><button type="button" class="art-lb__next" aria-label="Photo suivante">&rsaquo;</button>' : '');
      document.body.appendChild(lb);
      rootEl.classList.add('art-more-open');
      lbShow();
      var sx0 = 0;
      lb.addEventListener('touchstart', function (e) { sx0 = e.touches[0].clientX; }, { passive: true });
      lb.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - sx0;
        if (Math.abs(dx) > 50 && lbUrls.length > 1) lbNav(dx < 0 ? 1 : -1);
      }, { passive: true });
      lb.addEventListener('click', function (e) {
        var t = e.target;
        if (t.closest('.art-lb__prev')) lbNav(-1);
        else if (t.closest('.art-lb__next')) lbNav(1);
        else if (t.closest('.art-lb__close') || t === lb) closeLb();
      });
      updSticky();
    }

    /* panneau + infos */
    function closeMore() {
      [].forEach.call(root.querySelectorAll('.art-sc__more'), function (m) { m.hidden = true; });
      rootEl.classList.remove('art-more-open');
      updSticky();
    }
    function openMore(i) {
      var panel = root.querySelector('[data-more="' + i + '"]');
      if (panel) { panel.hidden = false; rootEl.classList.add('art-more-open'); updSticky(); }
    }

    document.addEventListener('keydown', function (e) {
      if (lb) {
        if (e.key === 'Escape') closeLb();
        if (e.key === 'ArrowLeft') lbNav(-1);
        if (e.key === 'ArrowRight') lbNav(1);
        return;
      }
      if (rootEl.classList.contains('art-more-open')) {
        if (e.key === 'Escape') closeMore();
        return;
      }
      if (hero) {
        var r = hero.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        if (e.key === 'ArrowLeft') go(idx - 1);
        if (e.key === 'ArrowRight') go(idx + 1);
      }
    });

    /* panier */
    function addToCart(card, add) {
      var vid = card.getAttribute('data-variant') || add.getAttribute('data-single');
      if (!vid) {
        var sizes = card.querySelector('.art-sc__sizes');
        if (sizes) {
          sizes.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
          sizes.classList.remove('is-nudge'); void sizes.offsetWidth; sizes.classList.add('is-nudge');
        }
        return;
      }
      var label = add.querySelector('[data-add-label]');
      var prev = label.textContent;
      add.classList.add('is-wait'); label.textContent = 'Ajout…'; syncSticky();
      var drawer = document.querySelector('cart-drawer');
      var body = { items: [{ id: Number(vid), quantity: 1 }] };
      if (drawer && drawer.getSectionsToRender) {
        body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }
      var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(base + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json(); }).then(function (res) {
        add.classList.remove('is-wait');
        if (res && res.status) {
          label.textContent = 'Indisponible'; syncSticky();
          setTimeout(function () { label.textContent = prev; syncSticky(); }, 1800);
          return;
        }
        label.textContent = 'Ajouté ✓'; syncSticky();
        setTimeout(function () { label.textContent = prev; syncSticky(); }, 1800);
        if (drawer && drawer.renderContents) { drawer.renderContents(res); }
        else { window.location.href = (window.Shopify && Shopify.routes && Shopify.routes.cart_url) || '/cart'; }
      }).catch(function () {
        add.classList.remove('is-wait'); label.textContent = prev; syncSticky();
      });
    }

    root.addEventListener('click', function (e) {
      var t = e.target;
      var openBtn = t.closest('[data-more-open]');
      if (openBtn) { openMore(openBtn.getAttribute('data-more-open')); return; }
      if (t.closest('[data-more-close]')) { closeMore(); return; }

      if (t.closest('[data-sticky-add]')) {
        var c0 = activeCard(), a0 = c0.querySelector('[data-add]');
        if (a0 && !a0.disabled) addToCart(c0, a0);
        return;
      }

      var slide = t.closest('.art-sc__gal-slide');
      if (slide) {
        var all = [].slice.call(slide.closest('.art-sc__prod').querySelectorAll('.art-sc__gal-slide'));
        openLb(all.map(function (s) { return s.getAttribute('data-zoom'); }), all.indexOf(slide));
        return;
      }

      var th = t.closest('[data-thumb]');
      if (th) {
        var gal = th.closest('.art-sc__prod').querySelector('[data-gal]');
        gal.scrollTo({ left: Number(th.getAttribute('data-thumb')) * gal.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
        return;
      }

      var rm = t.closest('[data-readmore]');
      if (rm) { openMore(prods.indexOf(rm.closest('.art-sc__prod'))); return; }

      var sz = t.closest('.art-sc__size');
      if (sz && !sz.disabled) {
        var card3 = sz.closest('.art-sc__prod');
        [].forEach.call(card3.querySelectorAll('.art-sc__size'), function (b) { b.classList.remove('is-selected'); });
        sz.classList.add('is-selected');
        card3.setAttribute('data-variant', sz.getAttribute('data-variant'));
        var pr = card3.querySelector('[data-price]');
        if (pr && sz.getAttribute('data-price')) pr.textContent = sz.getAttribute('data-price');
        var lbl = card3.querySelector('[data-add-label]');
        if (lbl) lbl.textContent = 'Ajouter au panier';
        syncSticky();
        return;
      }

      var add = t.closest('[data-add]');
      if (add && !add.disabled) addToCart(add.closest('.art-sc__prod'), add);
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', measure);
    window.addEventListener('load', measure);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
    setActive(0);
    measure();
  }

  function boot() {
    [].forEach.call(document.querySelectorAll('[data-art-showcase]'), initShowcase);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();